













































import {Component, Vue} from 'vue-property-decorator';
import {Challenge, getDailyChallenges} from "@/domain/challenges/challenge";

import {traineesClient} from "@/api/clients.context";
import {TraineeProfileModel} from "@/domain/trainees/TraineeProfileModel";

@Component({})

export default class learnStart extends Vue {

    private challenges: Challenge[] = getDailyChallenges();
    private id: string = '';
    private profile: TraineeProfileModel | null = null;

    async mounted() {
        this.id = this.$route.params.id;
        this.profile = await traineesClient.getProfile(this.id);
    }
}

